"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _locales = require("@meepshop/locales");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
var Cart = require("next/dynamic")["default"](function () {
  return import("@meepshop/images/lib/cart");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@meepshop/images/lib/cart")];
    },
    modules: ["../../../../store/cart-previewer/lib/previewer/Empty.js -> " + "@meepshop/images/lib/cart"]
  }
});

require("./styles/empty.less");

var styles = {
  "root": "store-cart-previewer__previewer-empty__root",
  "cart": "store-cart-previewer__previewer-empty__cart",
  "button": "store-cart-previewer__previewer-empty__button"
}; // typescript definition

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var onClose = _ref.onClose;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var _useTranslation = (0, _locales.useTranslation)('cart-previewer'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("div", null, t('cart')), /*#__PURE__*/_react["default"].createElement(Cart, {
    className: styles.cart
  }), /*#__PURE__*/_react["default"].createElement("p", null, t('empty-cart')), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.button,
    onClick: onClose
  }, t('go-back-to-store'))), /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            .".concat(styles.root, " {\n              color: ").concat(colors[3], ";\n            }\n\n            .").concat(styles.root, " p {\n              color: ").concat((0, _color["default"])(colors[3]).alpha(0.8), ";\n            }\n\n            .").concat(styles.cart, " {\n              fill: ").concat((0, _color["default"])(colors[3]).alpha(0.3), ";\n            }\n\n            .").concat(styles.button, " {\n              color: ").concat(colors[2], ";\n              background-color: ").concat(colors[4], ";\n              box-shadow: 0 1px 5px 0 ").concat((0, _color["default"])(colors[2]).alpha(0.2), ";\n            }\n          ")
    }
  }));
});

exports["default"] = _default;